module.exports = __webpack_public_path__ + "static/media/se_skrivhastighet_video.a100b69b.mov";